import script from "./JimsTradeTrackerCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./JimsTradeTrackerCategories.vue?vue&type=script&setup=true&lang=js"

import "./JimsTradeTrackerCategories.vue?vue&type=style&index=0&id=1a2a48b8&lang=scss"

const __exports__ = script;

export default __exports__